/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import {
  setSelectedGeoRegionAction,
  setSelectedGeoRegionIdsAction,
  setSelectedGeoRegionsAction,
  setIsCreateUserAction,
  setSelectedProfileAction,
  setSeverityValueAction,
  setSNMPValueAction,
  setEmailValueAction,
  setSelectedSnmpGroupAction,
  setIsCreateSnmpGroupAction,
  setSelectedSnmpAgentAction,
  setIsCreateEmailGroupAction,
  setSelectedEmailGroupAction,
  setSelectedSmtpEmailAction,
  setSystemPropertiesAction,
  setAccessControlSettingsAction,
  setSelectedTrapReceiveAgentAction,
  setGroupListAction,
  setSNMPEmailGroupsAction,
  setSelectedUserFileMgmtAction,
  setIsAddNewUserFileMgmtAction,
  setCurrentSiteGroupsAction,
  setSelectedSyslogReceiverAction,
  setServerConfigAction,
  setSelectedTaskTypeAction,
  setNotiGroupAction,
  setShowBannerAction,
  setSelectedBulkFileAction,
  setSuccessBulkUplaodAction,
  setFailedBulkUplaodAction,
  setDataPollingAction,
  setStartDateAction,
  setPasswordSettingsAction,
  setThresholdCrossingSettingProfileModelOpenModeAction,
  setThresholdCrossingSettingActionModelOpenModeAction,
  setThresholdCrossingSettingScheduleModelOpenModeAction,
  setThresholdCrossingSettingRuleModelOpenModeAction,
  setSelectedThresholdCrossingSettingProfileAction,
  setSelectedThresholdCrossingSettingActions,
  setSelectedThresholdCrossingSettingScheduleAction,
  setSelectedThresholdCrossingSettingRuleAction,
  setIsAddEditDeleteThresholdCrossingSettingProfileAction,
  setIsAddEditDeleteThresholdCrossingSettingActions,
  setIsAddEditDeleteThresholdCrossingSettingScheduleAction,
  setIsAddEditDeleteThresholdCrossingSettingRuleAction,
} from "./actions";

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setSelectedGeoRegion: setSelectedGeoRegionAction,
    setSelectedGeoRegionIds: setSelectedGeoRegionIdsAction,
    setSelectedGeoRegions: setSelectedGeoRegionsAction,
    setIsCreateUser: setIsCreateUserAction,
    setShowBanner: setShowBannerAction,
    setSelectedProfile: setSelectedProfileAction,
    setSeverityValue: setSeverityValueAction,
    setSNMPValue: setSNMPValueAction,
    setEmailValue: setEmailValueAction,
    setIsCreateSnmpGroup: setIsCreateSnmpGroupAction,
    setSelectedSnmpGroup: setSelectedSnmpGroupAction,
    setSelectedSnmpAgent: setSelectedSnmpAgentAction,
    setIsCreateEmailGroup: setIsCreateEmailGroupAction,
    setSelectedEmailGroup: setSelectedEmailGroupAction,
    setSelectedSmtpEmail: setSelectedSmtpEmailAction,
    setSystemProperties: setSystemPropertiesAction,
    setAccessControlSettings: setAccessControlSettingsAction,
    setSelectedTrapReceive: setSelectedTrapReceiveAgentAction,
    setGroupList: setGroupListAction,
    setSNMPEmailGroups: setSNMPEmailGroupsAction,
    setSelectedUserFileMgmt: setSelectedUserFileMgmtAction,
    setIsAddNewUserFileMgmt: setIsAddNewUserFileMgmtAction,
    setCurrentSiteGroups: setCurrentSiteGroupsAction,
    setSelectedSyslogReceiver: setSelectedSyslogReceiverAction,
    setServerConfig: setServerConfigAction,
    setSelectedTaskType: setSelectedTaskTypeAction,
    setSelectedNotifyGroup: setNotiGroupAction,
    setSelectedBulkFileUpload: setSelectedBulkFileAction,
    setFailedBulkUpload: setFailedBulkUplaodAction,
    setSuccessBulkUplaod: setSuccessBulkUplaodAction,
    setDataPolingProperties: setDataPollingAction,
    setStartDate: setStartDateAction,
    setPasswordSettings: setPasswordSettingsAction,
    setThresholdCrossingSettingProfileModelOpenMode : setThresholdCrossingSettingProfileModelOpenModeAction,
    setThresholdCrossingSettingActionModelOpenMode : setThresholdCrossingSettingActionModelOpenModeAction,
    setThresholdCrossingSettingScheduleModelOpenMode : setThresholdCrossingSettingScheduleModelOpenModeAction,
    setThresholdCrossingSettingRuleModelOpenMode : setThresholdCrossingSettingRuleModelOpenModeAction,
    setSelectedThresholdCrossingSettingProfile : setSelectedThresholdCrossingSettingProfileAction,
    setSelectedThresholdCrossingSettingAction : setSelectedThresholdCrossingSettingActions,
    setSelectedThresholdCrossingSettingSchedule : setSelectedThresholdCrossingSettingScheduleAction,
    setSelectedThresholdCrossingSettingRule : setSelectedThresholdCrossingSettingRuleAction,
    setIsAddEditDeleteThresholdCrossingSettingProfile : setIsAddEditDeleteThresholdCrossingSettingProfileAction,
    setIsAddEditDeleteThresholdCrossingSettingAction : setIsAddEditDeleteThresholdCrossingSettingActions,
    setIsAddEditDeleteThresholdCrossingSettingSchedule : setIsAddEditDeleteThresholdCrossingSettingScheduleAction,
    setIsAddEditDeleteThresholdCrossingSettingRule : setIsAddEditDeleteThresholdCrossingSettingRuleAction
  },
});

export const AdminReducers = adminSlice.reducer;
export const {
  setSelectedGeoRegion,
  setSelectedGeoRegionIds,
  setSelectedGeoRegions,
  setIsCreateUser,
  setShowBanner,
  setSelectedProfile,
  setSeverityValue,
  setSNMPValue,
  setEmailValue,
  setSelectedSnmpGroup,
  setIsCreateSnmpGroup,
  setSelectedSnmpAgent,
  setIsCreateEmailGroup,
  setSelectedEmailGroup,
  setSelectedSmtpEmail,
  setSystemProperties,
  setAccessControlSettings,
  setSelectedTrapReceive,
  setGroupList,
  setSNMPEmailGroups,
  setSelectedUserFileMgmt,
  setIsAddNewUserFileMgmt,
  setCurrentSiteGroups,
  setSelectedSyslogReceiver,
  setServerConfig,
  setSelectedTaskType,
  setSelectedNotifyGroup,
  setSelectedBulkFileUpload,
  setFailedBulkUpload,
  setSuccessBulkUplaod,
  setDataPolingProperties,
  setStartDate,
  setPasswordSettings,
  setThresholdCrossingSettingProfileModelOpenMode,
  setThresholdCrossingSettingActionModelOpenMode,
  setThresholdCrossingSettingScheduleModelOpenMode,
  setThresholdCrossingSettingRuleModelOpenMode,
  setSelectedThresholdCrossingSettingProfile,
  setSelectedThresholdCrossingSettingAction,
  setSelectedThresholdCrossingSettingSchedule,
  setSelectedThresholdCrossingSettingRule,
  setIsAddEditDeleteThresholdCrossingSettingProfile,
  setIsAddEditDeleteThresholdCrossingSettingAction,
  setIsAddEditDeleteThresholdCrossingSettingSchedule,
  setIsAddEditDeleteThresholdCrossingSettingRule
} = adminSlice.actions;
